<div class="chat-widget">
  <button
    type="button"
    class="chat-widget-toggle"
    data-testid="chat-widget-toggle"
    [attr.aria-label]="(chat.open() ? 'chat.close' : 'chat.open') | translate"
    (click)="toggle()"
  >
    <span class="material-symbols-outlined">{{ chat.open() ? 'close' : 'chat' }}</span>
  </button>

  @if (chat.open()) {
    <section
      class="chat-widget-panel"
      role="dialog"
      [attr.aria-label]="'chat.panelLabel' | translate"
      data-testid="chat-widget-panel"
    >
      <header class="chat-widget-header">
        <span>{{ 'chat.title' | translate }}</span>
      </header>

      <div
        class="chat-widget-messages"
        data-testid="chat-widget-messages"
        #messagesEl
        (scroll)="onMessagesScroll(messagesEl)"
      >
        @if (chat.loadingOlder()) {
          <p class="chat-widget-loading-older" data-testid="chat-widget-loading-older">
            {{ 'chat.loadingOlder' | translate }}
          </p>
        }
        @if (chat.historyLoading()) {
          <div class="chat-widget-skeleton" data-testid="chat-widget-history-loading">
            <div class="chat-widget-skeleton-bubble chat-widget-skeleton-bubble-user"></div>
            <div class="chat-widget-skeleton-bubble"></div>
          </div>
        }
        @if (!chat.historyLoading() && !chat.hasMessages()) {
          <p class="chat-widget-empty">{{ 'chat.empty' | translate }}</p>
        }
        @for (message of chat.messages(); track $index) {
          <div
            class="chat-widget-message"
            [class.chat-widget-message-user]="message.role === 'user'"
            [class.chat-widget-message-products]="isWideMessage(message, $index)"
          >
            <p #textEl [innerHTML]="message.text | chatFormat"></p>
            @if (message.products && message.products.length > 0) {
              <div class="chat-widget-carousel">
                <button
                  type="button"
                  class="chat-widget-carousel-arrow prev"
                  [attr.aria-label]="'chat.scrollPrev' | translate"
                  (click)="scrollCards(cardsRail, -1)"
                >
                  <span class="material-symbols-outlined mirrored">chevron_right</span>
                </button>
                <div class="chat-widget-cards no-scrollbar" #cardsRail>
                  @for (product of message.products; track product.skuCode) {
                    <div class="chat-widget-card">
                      <app-product-card [product]="product" [inlineVariantPicker]="true" />
                    </div>
                  }
                </div>
                <button
                  type="button"
                  class="chat-widget-carousel-arrow next"
                  [attr.aria-label]="'chat.scrollNext' | translate"
                  (click)="scrollCards(cardsRail, 1)"
                >
                  <span class="material-symbols-outlined">chevron_right</span>
                </button>
              </div>
            }
          </div>
        }
        @if (chat.sending()) {
          <div class="chat-widget-typing" role="status" [attr.aria-label]="'chat.typing' | translate">
            <span class="chat-widget-typing-dot"></span>
            <span class="chat-widget-typing-dot"></span>
            <span class="chat-widget-typing-dot"></span>
          </div>
        }
        @if (chat.error(); as errorKey) {
          <p class="chat-widget-error" data-testid="chat-widget-error">{{ errorKey | translate: chat.errorParams() }}</p>
        }
      </div>

      <form class="chat-widget-form" (submit)="submit($event)">
        <input
          type="text"
          class="chat-widget-input"
          data-testid="chat-widget-input"
          [attr.aria-label]="'chat.inputLabel' | translate"
          [placeholder]="'chat.placeholder' | translate"
          name="chatMessage"
          [ngModel]="draft()"
          (ngModelChange)="draft.set($event)"
        />
        <button
          type="submit"
          class="chat-widget-send"
          data-testid="chat-widget-send"
          [disabled]="chat.sending()"
        >
          {{ 'chat.send' | translate }}
        </button>
      </form>
    </section>
  }
</div>
